var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"breakdance-loading-spinner",style:(_vm.outerDivStyles)},[_c('div',{style:(_vm.innerDivStyles)}),_c('div',{style:(_vm.innerDivStyles)}),_c('div',{style:(_vm.innerDivStyles)}),_c('div',{style:(_vm.innerDivStyles)})])
}
var staticRenderFns = []

export { render, staticRenderFns }